import React from 'react'
import { NavIn3 } from '../components/componentNav/NavIn'
import { Politic } from '../components/ComponentExtras/Politica'

export function Deneder() {
  return (
    <>
        <NavIn3/>
        <Politic/>
    </>
  )
}

